import {SessionService} from "../services/session";
import {MenuItem, MenuItemList} from "../directives/navigation/userRecap";

export function menuItemFilter() {

  return function(items: MenuItemList, session: SessionService) {

    return items.filter((item) => {

      if ((session.isHost() || session.isHostRequested()) && item.label == "MENU.BECOME_HOST") {
        return false;
      }

      if (session.isGuest() && item.label == "MENU.CREATE_DINNER") {
        return false;
      }

      return true;
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/filters/menuItem.ts
 **/